import React from 'react'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts } from '@/utils/preset'
import { desktop, laptop, tabletL, tabletS, mobile } from '@/utils/media'
import { mq } from '@/utils/helpers'
import Headline from '@/components/app/Headline'
import Typography from '@/components/common/Typography'
import Bg from '@/components/app/Bg'
import All from '@/components/svg/All'

const AboutOverview = props => {
  return (
    <Root {...props}>
      <Head>
        <Title theme={props.theme}>
          FVPは、<strong>ERPの本質を<br />追究したシステム</strong>
        </Title>
      </Head>
      <Main>
        <Body variant="body1">
          ERPとは、Enterprise Resources Planning の略で、財務会計、販売管理、購買管理、在庫管理などの基幹業務をすべて一元管理・効率化する考え方です。FVPは、ERPによって企業の全体最適を実現するために設計されているため、すべての機能を月額料金の中でご利用いただけるようになっています。
        </Body>
        <Chart>
          <Chart_Content />
        </Chart>
      </Main>
    </Root>
  )
}

const Root = styled.div`
  padding: 100px 0 120px;
  @media ${mq.and(mobile)} {
    padding: 48px 0 64px;
  }
`

const Head = styled.div``

const Title = styled(Headline)`
  strong {
    color: ${props => props.theme.primary.base};
  }
  @media ${mq.and(desktop, laptop, tabletL)} {
    br {
      display: none;
    }
  }
`

const Main = styled.div`
  margin-top: 40px;
  @media ${mq.and(mobile)} {
    margin-top: 32px;
  }
`

const Body = styled(Typography)`
  margin: 0 auto;
  max-width: ${layouts.defs.contentMaxWidth.base}px;
  text-align: center;
  @media ${mq.and(tabletS)} {
    text-align: left;
    max-width: ${layouts.defs.contentMaxWidth.small}px;
  }
  @media ${mq.and(mobile)} {
    text-align: left;
    br {
      display: none;
    }
  }
`

const Chart = styled(Bg)`
  margin: 64px auto 0;
  max-width: 996px;
  text-align: center;
  padding: 38px;
  @media ${mq.and(mobile)} {
    margin-top: 48px;
    margin-left: ${layouts.defs.pad.mobile * -1}px;
    margin-right: ${layouts.defs.pad.mobile * -1}px;
    padding-left: ${layouts.defs.pad.mobile}px;
    padding-right: ${layouts.defs.pad.mobile}px;
  }
`

const Chart_Content = styled(All)`
  width: 100%;
`

export default ThemeConsumer(AboutOverview)
